import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22root-theme.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./fonts/dancing-script-latin.woff2%22,%22variable%22:%22--font-script%22,%22weight%22:%22400%20500%22,%22style%22:%22normal%22,%22display%22:%22swap%22,%22adjustFontFallback%22:false,%22fallback%22:[%22'Dancing%20Script%20Fallback'%22],%22preload%22:false}],%22variableName%22:%22dancingScript%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'dancingScript', 'Dancing Script Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
